export var getSingleElement = function getSingleElement(selector) {
  var el = document.querySelector(selector);
  if (!el) throw new Error("No element found with the id: ".concat(selector));
  return el;
};
export var emptyElem = function emptyElem(selectorOrElem) {
  if (typeof selectorOrElem === "string") getSingleElement(selectorOrElem).textContent = "";else selectorOrElem.textContent = "";
};
export var showElem = function showElem(elem) {
  var displayValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "block";
  if (!elem) return;
  elem.style.display = displayValue;
};
export var hideElem = function hideElem(elem) {
  if (!elem) return;
  elem.style.display = "none";
};
export function injectScriptTag(props) {
  var src = props.src,
    async = props.async,
    callback = props.callback,
    id = props.id;
  var script = document.createElement("script");
  script.type = "text/javascript";
  //By default, all the injected scripts are async
  if (async || async === undefined) {
    script.setAttribute("async", "");
  }
  script.src = src;
  if (id) script.id = id;
  if (callback) script.onload = function () {
    callback();
  };
  document.head.appendChild(script);
}